import { render, staticRenderFns } from "./ScrollData.vue?vue&type=template&id=1c89f3d0"
import script from "./ScrollData.vue?vue&type=script&lang=js"
export * from "./ScrollData.vue?vue&type=script&lang=js"
import style0 from "./ScrollData.vue?vue&type=style&index=0&id=1c89f3d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports